// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_m0-0";
export var discountCodeInput = "_m0-1";